import React from 'react'
import Wizard from 'src/pages/wizard'

function App() {
  return <Wizard />
}

export default App
